import { PaginatedResponse } from ".";

export interface AthleteItems extends PaginatedResponse {
  items: Athlete[];
}
export interface AthleteResponse {
  filterAthletes: AthleteItems;
}

export interface HeadShotUploadArgs {
  imageUrl: string;
  updateHeadshotDetails: boolean,
}

export interface AthleteEmailVerifyTypes {
  email: string;
  code: string,
}
export interface AthleteOnboardedResponse {
  user: {
    athleteOnboarded: boolean;
    id: string;
    __typename: "User";
  };
}

export interface AthleteSport {
  jerseyNumber: string;
  sportDetails: {
    bio: string;
    position: string;
  };
  sport: {
    id: string;
    name: string;
  };
}

export interface Athlete {
  id: string;
  firstName: string;
  lastName: string;
  athleteOnboarded: boolean;
  athleteSport: AthleteSport[];
  isFavorite: boolean;
  school: {
    id: string;
    name: string;
    nickname?: string | null;
    mascot?: string | null;
  };
  __typename: "User";
}

export interface athleteEmailSearchResponse {
  athleteEmailSearch: {
    id: string;
    firstName: string;
    lastName: string;
    sports: { id: string; name: string }[];
    school: {
      id: string;
      name: string;
    };
  };
}

export interface athleteSignUpResponse {
  athleteSignUp: string;
}

export interface identityVerificationResponse {
  initiateIdentityVerification: string;
}

export interface identityVerificationArgs {
  returnUrl: string;
}

export interface onboardUserAccountArgs {
  refreshUrl: string;
  returnUrl: string;
}

export interface onboardUserAccountResponse {
  onboardUserAccount: string;
}
export interface ConfirmSignupResponse {
  customConfirmSignup: {
    message: string;
    status: boolean;
  }

}

export interface RequestAthleteResponse {
  addRequestedAthlete: boolean;
}

export interface RequestAthleteArgs {
  requestedAthlete: {
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    rosterUrl: string;
    school: string;
    sport: string;
  };
}
export interface ConfirmSignupArgs {
  username: string;
  clientId: string;
  confirmationCode: string;
}

export interface RequestSponsorshipResponse {
  addRequestedSponsorship: boolean;
}

export interface RequestSponsorshipArgs {
  requestedSponsorship: {
    amount: number;
    athleteId: string;
    companyAddress: CompanyAddressDetailsInput;
    companyName: string;
    companyType: string;
    date: string;
    ein: string;
    email: string;
    name: string;
    phoneNumber: string;
    // schoolId: string;
    // sponsorId: string;
    sponsorshipDetails: string;
    sponsorshipDuration: string;
    // sportId: string;
    timeCommitment: string
    type: string;
  }
}
interface CompanyAddressDetailsInput {
  city: string;
  state: string;
  street: string;
  zip: string;
}

export interface GetStripeLoginLinkResponse {
  getStripeLoginLink: string | null;
}


export enum StripeVerificationStatus {
  PENDING = 'pending',
  VERIFIED = 'verified',
  UNVERIFIED = 'unverified',
}